import { getImageUploadKnownErrorsMap } from '@nextiva/engagement-ui';
import { isString, property } from 'lodash';
import axios from 'axios';
import uuid from 'uuid';

import * as CancelToken from 'utils/cancelToken';
import getUrl from 'utils/getUrl';

import { generateApiError } from './utils/apiErrorMessages';
import { getUploadData } from './utils/getUploadData';
import { mapSurveyImageFromApiModel } from './dataMapper/surveyImage';

const uploadImage = ({ id = uuid(), imageData, onUploadProgress }) => {
  const cancelToken = CancelToken.create(id);
  const filename = isString(imageData) ? imageData : imageData.name;

  return axios
    .post(getUrl.apiV2('images'), getUploadData(imageData), {
      onUploadProgress: ({ loaded, total }) => {
        const ratio = loaded / total;
        onUploadProgress(ratio);
      },
      cancelToken: cancelToken.token,
    })
    .catch(rejection => {
      CancelToken.remove(id);
      const isCancelled = axios.isCancel(rejection);
      const isClientError =
        !isCancelled && rejection.response && rejection.response.status < 500;

      return generateApiError({
        knownErrorsMap: getImageUploadKnownErrorsMap(filename),
        isClientError,
        isCancelled,
      })(rejection);
    })
    .then(data => {
      CancelToken.remove(id);
      return data;
    })
    .then(property('data.data'))
    .then(mapSurveyImageFromApiModel);
};

export const cancelImageUpload = id => {
  if (!CancelToken.has(id)) {
    return;
  }

  CancelToken.get(id).cancel();
  CancelToken.remove(id);
};

export default uploadImage;
